import { Box } from "@mui/material";

const INK = "#12100d";

/* 玄関背景D — 雲海の暁: 遠山の上をゆっくり流れる雲海と、夜明け前の金の気配 */
export default function ApproachD() {
  return (
    <Box sx={{ position: "fixed", inset: 0, zIndex: -1, overflow: "hidden", bgcolor: INK }}>
      {/* 未明の空 */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: `linear-gradient(180deg, ${INK} 0%, #16130f 38%, #221c13 62%, #2b2216 74%, #1b1815 88%, ${INK} 100%)`,
        }}
      />

      {/* 暁の気配（地平の一点がにじむ） */}
      <Box
        sx={{
          position: "absolute",
          left: "38%",
          top: "66%",
          width: "80vmin",
          height: "34vmin",
          transform: "translate(-50%, -50%)",
          background:
            "radial-gradient(ellipse 50% 45% at 50% 60%, rgba(212,180,110,0.14) 0%, rgba(179,147,85,0.06) 40%, rgba(212,180,110,0) 70%)",
          filter: "blur(4px)",
          animation: "kodoDawn 13s ease-in-out infinite alternate",
          "@keyframes kodoDawn": {
            "0%": { opacity: 0.75 },
            "100%": { opacity: 1 },
          },
        }}
      />

      {/* 遠山（最奥） */}
      <Box
        component="svg"
        viewBox="0 0 100 30"
        preserveAspectRatio="none"
        sx={{ position: "absolute", left: 0, right: 0, bottom: "14vh", width: "100%", height: "26vh" }}
      >
        <path d="M0,30 L0,18 Q10,13 18,16 Q28,20 38,13 Q46,8 54,13 Q64,19 74,15 Q86,10 100,16 L100,30 Z" fill="rgba(24,20,16,0.9)" />
      </Box>

      {/* 雲海（多層・異速でゆっくり流れる） */}
      {[
        { bottom: "20vh", height: "12vh", dur: 90, from: "-8%", to: "6%", alpha: 0.05, blur: 9 },
        { bottom: "15vh", height: "14vh", dur: 66, from: "5%", to: "-9%", alpha: 0.07, blur: 10 },
        { bottom: "9vh", height: "16vh", dur: 48, from: "-10%", to: "8%", alpha: 0.09, blur: 12 },
      ].map((c, i) => (
        <Box
          key={i}
          sx={{
            position: "absolute",
            left: "-25%",
            width: "150%",
            bottom: c.bottom,
            height: c.height,
            background: `radial-gradient(ellipse 32% 55% at 22% 55%, rgba(222,215,198,${c.alpha}), rgba(222,215,198,0) 70%),
                         radial-gradient(ellipse 38% 60% at 52% 45%, rgba(222,215,198,${c.alpha * 0.9}), rgba(222,215,198,0) 70%),
                         radial-gradient(ellipse 30% 50% at 80% 60%, rgba(212,180,110,${c.alpha * 0.5}), rgba(212,180,110,0) 70%)`,
            filter: `blur(${c.blur}px)`,
            animation: `kodoSea${i} ${c.dur}s ease-in-out infinite alternate`,
            [`@keyframes kodoSea${i}`]: {
              "0%": { transform: `translateX(${c.from})` },
              "100%": { transform: `translateX(${c.to})` },
            },
          }}
        />
      ))}

      {/* 近山（雲海から頭を出す・手前） */}
      <Box
        component="svg"
        viewBox="0 0 100 26"
        preserveAspectRatio="none"
        sx={{ position: "absolute", left: 0, right: 0, bottom: 0, width: "100%", height: "22vh" }}
      >
        <path d="M0,26 L0,14 Q8,9 16,12 Q26,16 36,10 Q44,6 52,11 Q60,15 70,12 Q84,8 100,14 L100,26 Z" fill="rgba(16,13,10,0.92)" />
        <path d="M0,26 L0,20 Q18,15 34,19 Q52,23 68,19 Q84,15 100,20 L100,26 Z" fill="rgba(10,8,6,0.98)" />
      </Box>

      {/* 手前の暗がり（文字の可読性） */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "radial-gradient(ellipse 120% 90% at 50% 115%, rgba(0,0,0,0.5), rgba(0,0,0,0) 55%)",
        }}
      />
    </Box>
  );
}
